import { __extends } from "tslib";
import { DeleteEmailTemplateRequest, DeleteEmailTemplateResponse } from "../models/index";
import { deserializeAws_restJson1DeleteEmailTemplateCommand, serializeAws_restJson1DeleteEmailTemplateCommand, } from "../protocols/Aws_restJson1";
import { getSerdePlugin } from "@aws-sdk/middleware-serde";
import { Command as $Command } from "@aws-sdk/smithy-client";
var DeleteEmailTemplateCommand = /** @class */ (function (_super) {
    __extends(DeleteEmailTemplateCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function DeleteEmailTemplateCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    DeleteEmailTemplateCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var handlerExecutionContext = {
            logger: logger,
            inputFilterSensitiveLog: DeleteEmailTemplateRequest.filterSensitiveLog,
            outputFilterSensitiveLog: DeleteEmailTemplateResponse.filterSensitiveLog,
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    DeleteEmailTemplateCommand.prototype.serialize = function (input, context) {
        return serializeAws_restJson1DeleteEmailTemplateCommand(input, context);
    };
    DeleteEmailTemplateCommand.prototype.deserialize = function (output, context) {
        return deserializeAws_restJson1DeleteEmailTemplateCommand(output, context);
    };
    return DeleteEmailTemplateCommand;
}($Command));
export { DeleteEmailTemplateCommand };
//# sourceMappingURL=DeleteEmailTemplateCommand.js.map